import { ASSET_PATHS } from '../../../utils/assetPath';

type ApprovalDetailsSectionIconVariant = 'default' | 'returned' | 'success' | 'error';

interface ApprovalDetailsSectionIconProps {
  alt?: string;
  className?: string;
  variant?: ApprovalDetailsSectionIconVariant;
}

function ApprovalDetailsSectionIcon({ alt, className = '', variant = 'default' }: ApprovalDetailsSectionIconProps) {
  const iconSrc =
    variant === 'returned'
      ? ASSET_PATHS.RETURNED_ICON
      : variant === 'success'
      ? ASSET_PATHS.SUCCESS_ICON
      : variant === 'error'
      ? ASSET_PATHS.ERROR_ICON
      : ASSET_PATHS.FOLDER_OPEN_ICON;

  const defaultAlt =
    variant === 'returned'
      ? 'Section has requested edits'
      : variant === 'success'
      ? 'Section completed'
      : variant === 'error'
      ? 'Section has errors'
      : 'Section not yet viewed';

  return (
    <span className={`approval-details-section-icon ${className}`.trim()}>
      <img
        alt={alt ?? defaultAlt}
        className='approval-details-section-icon__image'
        height={32}
        src={iconSrc}
        width={32}
      />
    </span>
  );
}

export default ApprovalDetailsSectionIcon;
